// removed by extract-text-webpack-plugin
module.exports = {"Card":"_2-C9gtC-_0gO_3H39UGBE8","Image":"_1U5L3LyzhE41RnELI5sHdq","Ctrl":"_2FGsY5pfsMdfa-RISdmwKo","Count":"_3eg2EMfdfUliE8923mLqIL","Date":"_1O42Hlf8f5J9uq_ici1YHI","Btn":"_3b9cd7PKO68uka7js30mAW","Icon":"_3uGO-mwT4n7TZ3lX2J_6d2"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Utils/ReportWidget/styles.module.css
// module id = 593
// module chunks = 0